<template>
  <v-navigation-drawer
    v-if="$store.state.showMenuDrawer || $vuetify.breakpoint.lgAndUp"
    v-click-outside="() => $store.state.showMenuDrawer = false"
    fixed
    permanent
    expand-on-hover
    :mini-variant="isMini"
    @update:mini-variant="onMiniVariantUpdate"
    width="220"
    mini-variant-width="64"
    style="padding-top: 94px;"
  >
    <div class="d-flex align-center justify-space-between pa-4">
      <div class="d-flex gap-5 align-center" style="gap: 10px">
        <v-img
          v-if="!$vuetify.theme.dark && !isMini"
          :src="require('../assets/logo-light.png')"
          width="170"
          height="30"
          @click="$router.push('/')"
          style="cursor: pointer"
        />

        <v-img
          v-if="!$vuetify.theme.dark && isMini"
          :src="require('../assets/logo-icon-light.png')"
          width="20"
          height="30"
          @click="$router.push('/')"
          style="cursor: pointer"
        />

        <v-img
          v-if="$vuetify.theme.dark && !isMini"
          :src="require('../assets/logo-dark.png')"
          width="170"
          height="30"
          @click="$router.push('/')"
          style="cursor: pointer"
        />

        <v-img
          v-if="$vuetify.theme.dark && isMini"
          :src="require('../assets/logo-icon-dark.png')"
          width="20"
          height="30"
          @click="$router.push('/')"
          style="cursor: pointer"
        />
      </div>
    </div>

    <v-list class="mt-6">
      <!-- Página Inicial -->
      <v-list-item class="d-flex justify-start">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              :class="{ 'primary white--text': $route.path === '/', 'primary--text': $route.path !== '/' }"
              outlined
              style="
                display: flex;
                justify-content: flex-start;
                padding: 0 8px;
                font-weight: normal;
                text-transform: none;
              "
              :min-width="!isMini ? 186 : 38"
              @click="$router.push('/')"
            >
              <div v-if="!isMini" class="d-flex align-center">
                <v-icon size="20" style="margin-right: 16px">mdi-home</v-icon>Página Inicial
              </div>
              <div v-else>
                <v-icon size="20">mdi-home</v-icon>
              </div>
            </v-btn>
          </template>
          <span>Página Inicial</span>
        </v-tooltip>
      </v-list-item>

      <!-- Tópico 1 -->
      <v-list-item class="d-flex justify-start">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              :class="{ 'primary white--text': isActive('/topico-1'), 'primary--text': !isActive('/topico-1') }"
              outlined
              style="
                display: flex;
                justify-content: flex-start;
                padding: 0 8px;
                font-weight: normal;
                text-transform: none;
              "
              :min-width="!isMini ? 186 : 38"
              @click="$router.push('/topico-1')"
            >
              <div v-if="!isMini" class="d-flex align-center">
                <v-icon size="20" style="margin-right: 16px">mdi-book-open-blank-variant-outline</v-icon>Tópico 1
              </div>
              <div v-else>
                <v-icon size="20">mdi-book-open-blank-variant-outline</v-icon>
              </div>
            </v-btn>
          </template>
          <span>Tópico 1 - Normas gerais de circulação e conduta</span>
        </v-tooltip>
      </v-list-item>

      <!-- Tópico 2 -->
      <v-list-item class="d-flex justify-start">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              :class="{ 'primary white--text': isActive('/topico-2'), 'primary--text': !isActive('/topico-2') }"
              outlined
              style="
                display: flex;
                justify-content: flex-start;
                padding: 0 8px;
                font-weight: normal;
                text-transform: none;
              "
              :min-width="!isMini ? 186 : 38"
              @click="$router.push('/topico-2')"
            >
              <div v-if="!isMini" class="d-flex align-center">
                <v-icon size="20" style="margin-right: 16px">mdi-book-open-blank-variant-outline</v-icon>Tópico 2
              </div>
              <div v-else>
                <v-icon size="20">mdi-book-open-blank-variant-outline</v-icon>
              </div>
            </v-btn>
          </template>
          <span>Tópico 2 - Sinalização viária</span>
        </v-tooltip>
      </v-list-item>

      <!-- Tópico 3 -->
      <v-list-item class="d-flex justify-start">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              :class="{ 'primary white--text': isActive('/topico-3'), 'primary--text': !isActive('/topico-3') }"
              outlined
              style="
                display: flex;
                justify-content: flex-start;
                padding: 0 8px;
                font-weight: normal;
                text-transform: none;
              "
              :min-width="!isMini ? 186 : 38"
              @click="$router.push('/topico-3')"
            >
              <div v-if="!isMini" class="d-flex align-center">
                <v-icon size="20" style="margin-right: 16px">mdi-book-open-blank-variant-outline</v-icon>Tópico 3
              </div>
              <div v-else>
                <v-icon size="20">mdi-book-open-blank-variant-outline</v-icon>
              </div>
            </v-btn>
          </template>
          <span>Tópico 3 - Direitos e deveres do condutor</span>
        </v-tooltip>
      </v-list-item>

      <!-- Referências -->
      <v-list-item class="d-flex justify-start">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              :class="{ 'primary white--text': $route.path === '/referencias', 'primary--text': $route.path !== '/referencias' }"
              outlined
              style="
                display: flex;
                justify-content: flex-start;
                padding: 0 8px;
                font-weight: normal;
                text-transform: none;
              "
              :min-width="!isMini ? 186 : 38"
              @click="$router.push('/referencias')"
            >
              <div v-if="!isMini" class="d-flex align-center">
                <v-icon size="20" style="margin-right: 16px">mdi-bookshelf</v-icon>Referências
              </div>
              <div v-else>
                <v-icon size="20">mdi-bookshelf</v-icon>
              </div>
            </v-btn>
          </template>
          <span>Referências</span>
        </v-tooltip>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      isMini: true,
    };
  },
  methods: {
    onMiniVariantUpdate(val) {
      this.isMini = val;
    },
    isActive(basePath) {
      return this.$route.path.startsWith(basePath);
    },
  },
};
</script>

<style scoped>
.btn-topico {
  cursor: pointer;
  padding-left: 36px;
}

@media (max-width: 600px) {
  .btn-topico {
    padding-left: 4px;
  }
}

.btn-topico:hover {
  background: rgba(0, 0, 0, 0.03);
}

a {
  width: 100%;
  color: #333 !important;
  text-decoration: none;
}

.v-btn:not(.v-btn--round).v-size--default {
  padding: 0;
}

.v-list-item {
  padding: 0 8px;
}
</style>
